import axios from 'axios'
import { config } from '../../Constants'

export const reportApi = {
  createReport,
  search,
  getReportsPage,
  deleteReport
}

function createReport(user, report) {
  return instance.post('/api/report/create', report, {
    headers: {
      'Content-type': 'application/json',
      'Authorization': basicAuth(user)
    }
  })
}

function deleteReport(user, id) {
  return instance.delete(`/api/report/${id}`, {
    headers: { 'Authorization': basicAuth(user) }
  })
}
function getReportsPage(user, offset) {
  const url = '/api/report/paged?offset='+offset
  return instance.get(url, {
    headers: { 'Authorization': basicAuth(user) }
  })
}

function search(searchRquest) {
  return instance.post('/api/report/search', searchRquest, {
    headers: {
      'Content-type': 'application/json'
    }
  })
}
// -- Axios

const instance = axios.create({
  baseURL: config.url.API_BASE_URL
})

// -- Helper functions

function basicAuth(user) {
  return `Basic ${user.authdata}`
}
